var exports = {
  "p_": "list__5TYFws",
  "Nr": "card__em6gzM",
  "wx": "header__FwPBUn",
  "zD": "titleLink__d549Un",
  "gr": "titleIcon__WMufd5",
  "oV": "closedBadge__DiYqlz",
  "jf": "statusRow__-yzCyF",
  "qS": "statusText__HLsw_G",
  "rI": "statusButton__OCUuPB",
  "aA": "mutationError__itUP3T",
};

module.exports = exports;
